module.exports = __webpack_public_path__ + "img/img5.4aa0f61f.png";